"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

require("./index.css");

var _commons = require("egov-ui-kit/utils/commons");

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _api = require("egov-ui-kit/utils/api");

var _store = require("ui-redux/store");

var _store2 = _interopRequireDefault(_store);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timelineButtonLabelStyle = {
  lineHeight: 1,
  color: "#ffffff",
  fontWeight: 500
};
var timelineButtonContainerStyle = {
  lineHeight: 1
};

var statusContainerStyle = {
  display: "inline-block",
  marginRight: "3px"
};

var nameContainerStyle = {
  display: "inline-block"
};

var displayBlock = {
  display: "block",
  marginBottom: 5
};
var timelineIconCommonStyle = {
  height: "38px",
  width: "38px",
  borderRadius: "50%",
  padding: "7px",
  marginLeft: "-7px"
};

var statusCommonIconStyle = (0, _extends3.default)({}, timelineIconCommonStyle, {
  backgroundColor: "#ffffff",
  boxShadow: "0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)",
  border: "solid 1px #fe7a51"
});

var statusResolvedIconStyle = (0, _extends3.default)({}, timelineIconCommonStyle, {
  backgroundColor: "#22b25f",
  boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.22)",
  border: "solid 1px #22b25f"
});

var statusRejectedIconStyle = (0, _extends3.default)({}, timelineIconCommonStyle, {
  backgroundColor: "#e74c3c",
  // boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.22)",
  border: "solid 1px #e74c3c"
});

var callIconStyle = {
  marginLeft: "17px",
  height: "17px",
  width: "17px",
  borderRadius: "50%",
  position: "absolute",
  top: "0px"
};

var connectorStyle = {
  display: "block",
  border: "solid 1px #fe7a51",
  minHeight: "28px"
};

var StatusIcon = function StatusIcon(_ref) {
  var status = _ref.status;

  switch (status) {
    case "open":
    case "pending":
    case "pendingkmcgroapproval":
      return _react2.default.createElement(_components.Icon, { action: "custom", name: "file-plus", style: statusCommonIconStyle, color: "#fe7a51" });
    case "reassignrequested":
      return _react2.default.createElement(_components.Icon, { action: "custom", name: "reassign-request", style: statusCommonIconStyle, color: "#fe7a51" });
    case "assigned":
    case "attended":
    case "re-assign":
    case "escalatedlevel1pending":
    case "escalatedlevel2pending":
    case "escalatedlevel1assigned":
    case "escalatedlevel2assigned":
      return _react2.default.createElement(_components.Icon, { action: "custom", name: "file-send", style: statusCommonIconStyle, color: "#fe7a51" });
    case "rejected":
      return _react2.default.createElement(_components.Icon, { action: "content", name: "clear", style: statusRejectedIconStyle, color: "#FFFFFF" });
    case "resolved":
      return _react2.default.createElement(_components.Icon, { action: "action", name: "done", style: statusResolvedIconStyle, color: "#FFFFFF" });
    case "closed":
      return _react2.default.createElement(_components.Icon, { action: "action", name: "stars", style: statusResolvedIconStyle, color: "#FFFFFF" });
  }
};

//prventing number of times showing button for duplicate status
var openStatusCount = 0;
var rejectStatusCount = 0;
var resolveStatusCount = 0;
var assigneeStatusCount = 0;
var reassignRequestedCount = 0;
var noReopen = true;

var getImageSource = function getImageSource(imageSource, size) {
  var images = imageSource && imageSource.split(",").map(function (url) {
    return url.trim();
  }).filter(function (url) {
    return url.length > 0;
  });

  if (images && !images.length) {
    console.error("No valid image URLs found");
    return null;
  }

  var selectedImage = images && images[0];
  //   switch (size) {
  //     case "small":
  //       selectedImage = images.find((img) => img.includes("small")) || images[0];
  //       break;
  //     case "medium":
  //       selectedImage = images.find((img) => img.includes("medium")) || images[0];
  //       break;
  //     case "large":
  //     default:
  //       selectedImage = images.find((img) => img.includes("large")) || images[0];
  //   }

  // Validate selected image URL
  if (selectedImage && selectedImage.startsWith("http")) {
    return selectedImage;
  } else {
    console.error("Invalid image URL selected");
    return null;
  }
};

// const getImageSource = (imageSource, size) => {
//   const images = imageSource.split(",");
//   if (!images.length) {
//     return null;
//   }
//   switch (size) {
//     case "small":
//       imageSource = images[2];
//       break;
//     case "medium":
//       imageSource = images[1];
//       break;
//     case "large":
//     default:
//       imageSource = images[0];
//   }
//   return imageSource || images[0];
// };

var handleLevel1 = function handleLevel1(timeline1, timeline2) {
  if (timeline1.status === "escalatedlevel1pending") {
    if (timeline2.status === "resolved") return "ES_COMPLAINT_ESCALATED_LEVEL1_HEADER";else return "ES_COMPLAINT_ESCALATED_LEVEL1_SLA_BREACH";
  }
};

// const getEscalatingStatus = (timeline, status) => {
//   if (timeline && timeline.length > 2) {
//     if (timeline[0].status === "escalatedlevel1pending") return handleLevel1(timeline[0], timeline[1]);

//     if (timeline[0].status === "escalatedlevel2pending") {
//       if (timeline[1].status === "resolved") return "ES_COMPLAINT_ESCALATED_LEVEL2_HEADER";
//       else if (timeline[1].status === "escalatedlevel1pending" && status === "escalatedlevel1pending") return handleLevel1(timeline[1], timeline[2]);
//       else return "ES_COMPLAINT_ESCALATED_LEVEL2_SLA_BREACH";
//     }
//   }
// };

var getEscalatingStatus = function getEscalatingStatus(timeline, status) {
  if (timeline && timeline.length > 0) {
    if (status === "escalatedlevel1pending") {
      var statusIndex = timeline.findIndex(function (action) {
        return action.status === status;
      });
      var action = timeline.filter(function (action, index) {
        return index === statusIndex + 1;
      });

      if (action && action[0] && action[0].length > 0 && action[0].status === "resolved") return "ES_COMPLAINT_ESCALATED_LEVEL1_HEADER";else return "Complaint pending at GRO";
    }

    if (status === "escalatedlevel2pending") {
      var _statusIndex = timeline.findIndex(function (action) {
        return action.status === status;
      });
      var _action = timeline.filter(function (action, index) {
        return index === _statusIndex + 1;
      });

      if (_action && _action[0] && _action[0].length > 0 && _action[0].status === "resolved") return "ES_COMPLAINT_ESCALATED_LEVEL2_HEADER";else return "Complaint pending at GRO";
    }
  }
  return;
};

var StatusContent = function StatusContent(_ref2) {
  var stepData = _ref2.stepData,
      currentStatus = _ref2.currentStatus,
      changeRoute = _ref2.changeRoute,
      feedback = _ref2.feedback,
      rating = _ref2.rating,
      servicetype = _ref2.servicetype,
      role = _ref2.role,
      filedBy = _ref2.filedBy,
      allDesignation = _ref2.allDesignation,
      filedUserMobileNumber = _ref2.filedUserMobileNumber,
      reopenValidChecker = _ref2.reopenValidChecker,
      empRejectCount = _ref2.empRejectCount,
      empResolvedCount = _ref2.empResolvedCount,
      timeLine = _ref2.timeLine;
  var action = stepData.action,
      date = stepData.when,
      media = stepData.media,
      status = stepData.status,
      comments = stepData.comments,
      employeeName = stepData.employeeName,
      employeeDesignation = stepData.employeeDesignation,
      employeeDepartment = stepData.employeeDepartment,
      complaintNo = stepData.businessKey,
      groName = stepData.groName,
      department = stepData.department,
      designation = stepData.designation,
      employeeMobileNumber = stepData.employeeMobileNumber,
      groMobileNumber = stepData.groMobileNumber,
      groDesignation = stepData.groDesignation;

  var state = _store2.default.getState();

  var value = stepData && stepData.by;

  var createdBy = value && value.split(":")[1];

  var departmentName = "";
  var designationName = "";
  var userRole = process.env.REACT_APP_NAME;

  if (department) {
    var complaints = state.complaints;
    var departmentById = complaints.pgrDepartment;
    departmentName = departmentById && departmentById[department] && departmentById[department].name;
  }
  if (designation) {
    var designationArray = allDesignation.filter(function (item) {
      return item.code == designation;
    });
    designationName = designationArray && designationArray.length > 0 && designationArray[0].name;
  }

  var currDate = new Date().getTime();
  var resolvedDate = new Date(date).getTime();
  var isReopenValid = currDate - resolvedDate <= 86400000 * 7; //reopenValidChecker;

  switch (status) {
    case "open":
      //case "pendingkmcgroapproval":
      openStatusCount++;
      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
        _react2.default.createElement(_translationNode2.default, {
          labelClassName: "dark-color complaint-timeline-status",
          containerStyle: filedBy && filedBy.includes("@CSR") ? displayBlock : statusContainerStyle,
          label: "" + (action === "reopen" ? "Complaint Re-opened" : role !== "citizen" ? filedBy ? filedBy.includes("@CSR") ? "ES_COMPLAINT_FILED_BY_CSR" : "ES_COMMON_FILED_BY" : "Complaint Filed" : "Complaint Filed")
        }),
        action !== "reopen" && role !== "citizen" && filedBy && _react2.default.createElement(_translationNode2.default, {
          label: filedBy.includes("@CSR") ? filedBy.replace("@CSR", "") : filedBy,
          containerStyle: nameContainerStyle,
          fontSize: filedBy.includes("@CSR") ? 12 : 14,
          dark: filedBy.includes("@CSR") ? false : true
        }),
        role !== "citizen" && action !== "reopen" && filedUserMobileNumber && _react2.default.createElement(
          "a",
          {
            className: "citizen-mobileNumber-style",
            href: "tel:+91" + filedUserMobileNumber,
            style: { textDecoration: "none", position: "relative" }
          },
          _react2.default.createElement(_components.Icon, { action: "communication", name: "call", style: callIconStyle, color: "#22b25f" }),
          _react2.default.createElement(
            "span",
            {
              style: {
                fontSize: filedBy.includes("@CSR") ? 12 : 14,
                marginLeft: "43px"
              }
            },
            "+91 " + filedUserMobileNumber
          )
        ),
        action === "reopen" && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "rainmaker-small-font complaint-timeline-comments",
            containerStyle: { width: "192px" },
            label: comments ? comments.split(";")[0] : ""
          }),
          media && _react2.default.createElement(
            "div",
            { style: { display: "flex" } },
            media.map(function (image, index) {
              var imgUrl = getImageSource(image, "small");
              return imgUrl && _react2.default.createElement(
                "div",
                {
                  style: { marginRight: 8 },
                  className: "complaint-detail-detail-section-padding-zero",
                  id: "complaint-timeline-reopen-" + openStatusCount + "-image-" + index,
                  key: index
                },
                _react2.default.createElement(_components.Image, {
                  style: {
                    width: "97px",
                    height: "93px"
                  },
                  size: "medium",
                  source: imgUrl,
                  onClick: function onClick() {
                    return window.open(getImageSource(image, "small"), "Image");
                  }
                })
              );
            })
          ),
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "rainmaker-small-font complaint-timeline-status",
            containerStyle: { width: "192px" },
            label: comments && comments.split(";")[1] ? "\" " + comments.split(";")[1] + " \"" : ""
          })
        ),
        media && _react2.default.createElement(
          "div",
          { style: { display: "flex" } },
          media.map(function (image, index) {
            var imgUrl = getImageSource(image, "small");
            return imgUrl && _react2.default.createElement(
              "div",
              {
                style: { marginRight: 8 },
                className: "complaint-detail-detail-section-padding-zero",
                id: "complaint-details-resolved-" + resolveStatusCount + "-image=" + index,
                key: index
              },
              _react2.default.createElement(_components.Image, {
                style: {
                  width: "97px",
                  height: "93px"
                },
                size: "medium",
                source: imgUrl,
                onClick: function onClick() {
                  return window.open(getImageSource(image, "small"), "Image");
                } // changeRoute.push(`/image?source=${image}`)
              })
            );
          })
        )
      );
    case "assigned":
    case "attended":
    case "pendingkmcgroapproval":
    case "escalatedlevel1assigned":
    case "escalatedlevel2assigned":
    case "escalatedlevel1pending":
    case "escalatedlevel2pending":
      assigneeStatusCount++;
      switch (role && role.toLowerCase()) {
        case "ao":
        case "citizen":
        case "csr":

          return _react2.default.createElement(
            "div",
            { className: "complaint-timeline-content-section" },
            _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
            _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color complaint-timeline-status",
              containerStyle: statusContainerStyle,
              label: "" + (action == "assign" ? employeeName ? "Assigned to " : "Complaint Assigned" : employeeName ? "Re-Assigned to " : status === "escalatedlevel1pending" ? getEscalatingStatus(timeLine, status) : status === "escalatedlevel2pending" ? getEscalatingStatus(timeLine, status) : status === "attended" ? "Complaint Attended" : status === "pendingkmcgroapproval" ? "Pending for KMC GRO Approval" : "Complaint Re-Assigned")
            }),
            employeeName && userRole !== "Citizen" && (createdBy == "Citizen" ? _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color", containerStyle: nameContainerStyle, label: "" + employeeName }) : servicetype == "1" ? _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color",
              containerStyle: nameContainerStyle,
              label: employeeName + " by GRO(" + groName + " , " + departmentName + " , " + designationName + ")"
            }) : _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color", containerStyle: nameContainerStyle, label: "" + employeeName })),
            employeeMobileNumber && assigneeStatusCount === 1 && _react2.default.createElement(
              "a",
              { className: "pgr-call-icon", href: "tel:+91" + employeeMobileNumber, style: { textDecoration: "none", position: "relative" } },
              _react2.default.createElement(_components.Icon, { action: "communication", name: "call", style: callIconStyle, color: "#22b25f" }),
              _react2.default.createElement(
                "span",
                { style: { marginLeft: "43px" } },
                "+91 " + employeeMobileNumber
              )
            ),
            _react2.default.createElement(_translationNode2.default, {
              labelClassName: "rainmaker-small-font complaint-timeline-department"
              // containerStyle={{ width: "192px" }}
              , label: employeeDesignation
            }),
            _react2.default.createElement(_translationNode2.default, {
              labelClassName: "rainmaker-small-font complaint-timeline-department"
              // containerStyle={{ width: "192px" }}
              , label: employeeDepartment
            }),
            media && _react2.default.createElement(
              "div",
              { style: { display: "flex" } },
              media.map(function (image, index) {
                var imgUrl = getImageSource(image, "small");
                return imgUrl && _react2.default.createElement(
                  "div",
                  {
                    style: { marginRight: 8 },
                    className: "complaint-detail-detail-section-padding-zero",
                    id: "complaint-details-resolved-" + resolveStatusCount + "-image=" + index,
                    key: index
                  },
                  _react2.default.createElement(_components.Image, {
                    style: {
                      width: "97px",
                      height: "93px"
                    },
                    size: "medium",
                    source: imgUrl,
                    onClick: function onClick() {
                      return window.open(getImageSource(image, "small"), "Image");
                    } // changeRoute.push(`/image?source=${image}`)
                  })
                );
              })
            ),
            _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-comments", containerStyle: { width: "192px" }, label: comments })
          );
          break;
        case "eo":
        case "employee":
          return _react2.default.createElement(
            "div",
            { className: "complaint-timeline-content-section" },
            _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
            groName && _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color complaint-timeline-status",
              containerStyle: statusContainerStyle,
              label: "" + (action == "assign" ? groName ? "ES_COMPLAINT_DETAILS_ASSIGNED_BY" : "Complaint Assigned" : groName ? "ES_COMPLAINT_DETAILS_REASSIGNED_BY" : status === "escalatedlevel1pending" ? getEscalatingStatus(timeLine, status) : status === "escalatedlevel2pending" ? getEscalatingStatus(timeLine, status) : "Complaint Re-Assigned")
            }),
            employeeName && userRole !== "Citizen" && _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color",
              containerStyle: nameContainerStyle,
              label: employeeName + ", " + departmentName + " , " + designationName
            }),
            role.toLowerCase() !== "eo" ? employeeName && _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color complaint-timeline-status",
              containerStyle: statusContainerStyle,
              label: "" + (action == "assign" ? employeeName ? groName ? "to" : "Assigned to " : "Complaint Assigned" : employeeName ? groName ? "to" : "Re-Assigned to " : status === "escalatedlevel1pending" ? getEscalatingStatus(timeLine, status) : status === "escalatedlevel2pending" ? getEscalatingStatus(timeLine, status) : "Complaint Re-Assigned")
            }) : _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color complaint-timeline-status",
              containerStyle: statusContainerStyle,
              label: "" + (action == "assign" ? employeeName ? groName ? "to" : "Assigned to " : "Complaint Assigned" : employeeName ? groName ? "to" : "Re-Assigned to " : status === "escalatedlevel1pending" ? getEscalatingStatus(timeLine, status) : status === "escalatedlevel2pending" ? getEscalatingStatus(timeLine, status) : "Complaint Re-Assigned")
            }),
            employeeName && userRole !== "Citizen" && _react2.default.createElement(_translationNode2.default, {
              labelClassName: "dark-color",
              containerStyle: nameContainerStyle,
              label: employeeName + ", " + departmentName + "," + designationName
            }),
            groName && _react2.default.createElement(_translationNode2.default, {
              labelClassName: "rainmaker-small-font complaint-timeline-designation",
              containerStyle: { width: "192px" },
              label: "" + groDesignation
            }),
            media && _react2.default.createElement(
              "div",
              { style: { display: "flex" } },
              media.map(function (image, index) {
                var imgUrl = getImageSource(image, "small");
                return imgUrl && _react2.default.createElement(
                  "div",
                  {
                    style: { marginRight: 8 },
                    className: "complaint-detail-detail-section-padding-zero",
                    id: "complaint-details-resolved-" + resolveStatusCount + "-image=" + index,
                    key: index
                  },
                  _react2.default.createElement(_components.Image, {
                    style: {
                      width: "97px",
                      height: "93px"
                    },
                    size: "medium",
                    source: imgUrl,
                    onClick: function onClick() {
                      return window.open(getImageSource(image, "small"), "Image");
                    }
                  })
                );
              })
            ),
            _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-comments", containerStyle: { width: "192px" }, label: comments })
          );
          break;
        // default:
        //   return (
        //     <div className="complaint-timeline-content-section">
        //       <Label labelClassName="rainmaker-small-font complaint-timeline-date" label={getDateFromEpoch(date)} />
        //       <Label
        //         labelClassName="dark-color complaint-timeline-status"
        //         containerStyle={statusContainerStyle}
        //         label={`${action == "assign" ? "ES_COMPLAINT_ASSIGNED_HEADER" : "Complaint Re-Assigned"}`}
        //       />
        //     </div>
        //   );
      }
    case "reassignrequested":
      reassignRequestedCount++;

      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
        role === "citizen" && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color complaint-timeline-status",
            containerStyle: statusContainerStyle,
            label: "" + (groName ? "Complaint is being re-assigned by" : "Complaint is being Re-Assigned")
          }),
          groName && _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color", containerStyle: nameContainerStyle, label: "" + groName })
        ),
        role !== "citizen" && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color complaint-timeline-status",
            containerStyle: statusContainerStyle,
            label: "" + (employeeName ? "Re-Assign requested by" : "Re-assign Requested")
          }),
          employeeName && userRole !== "Citizen" && _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color",
            containerStyle: nameContainerStyle,
            label: employeeName + ", " + departmentName + " , " + designationName
          }),
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "rainmaker-small-font complaint-timeline-comments",
            containerStyle: { width: "192px" },
            label: comments ? comments.split(";")[0] : ""
          }),
          _react2.default.createElement(_translationNode2.default, {
            labelClassName: "rainmaker-small-font complaint-timeline-comments",
            containerStyle: { width: "192px" },
            label: comments && comments.split(";")[1] ? "\" " + comments.split(";")[1] + " \"" : ""
          })
        )
      );

    case "rejected":
      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
        _react2.default.createElement(
          "div",
          { className: "d-flex" },
          _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color complaint-timeline-status", label: "Complaint has been Rejected  \xA0" }),
          employeeName && userRole !== "Citizen" && (createdBy == "GRO" ? _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color",
            containerStyle: nameContainerStyle,
            label: "by GRO ( " + employeeName + ", " + departmentName + ", " + designationName + ")"
          }) : _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color",
            containerStyle: nameContainerStyle,
            label: "by " + employeeName + ", " + departmentName + ", " + designationName
          }))
        ),
        media && _react2.default.createElement(
          "div",
          { style: { display: "flex" } },
          media.map(function (image, index) {
            var imgUrl = getImageSource(image, "small");
            return imgUrl && _react2.default.createElement(
              "div",
              {
                style: { marginRight: 8 },
                className: "complaint-detail-detail-section-padding-zero",
                id: "complaint-details-resolved-" + rejectStatusCount + "-image=" + index,
                key: index
              },
              _react2.default.createElement(_components.Image, {
                style: {
                  width: "97px",
                  height: "93px"
                },
                size: "medium",
                source: imgUrl,
                onClick: function onClick() {
                  return window.open(getImageSource(image, "small"), "Image");
                }
              })
            );
          })
        ),
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font", containerStyle: { width: "192px" }, label: comments ? comments.split(";")[0] : "" }),
        _react2.default.createElement(_translationNode2.default, {
          labelClassName: "rainmaker-small-font complaint-timeline-comments",
          containerStyle: { width: "192px" },
          label: comments && comments.split(";")[1] ? "\" " + comments.split(";")[1] + " \"" : ""
        }),
        currentStatus === "rejected" && (role === "citizen" || role === "csr") && _react2.default.createElement(
          "div",
          { className: "rainmaker-displayInline" },
          stepData.hasOwnProperty("showButton") && stepData.showButton && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            role !== "csr" && _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  changeRoute.push("/feedback/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "RATE", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            ),
            _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  role === "citizen" ? changeRoute.push("/reopen-complaint/" + encodeURIComponent(complaintNo)) : changeRoute.push("/reopen-complaint/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "REOPEN", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            )
          ),
          stepData.hasOwnProperty("showRateButton") && stepData.showRateButton && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  changeRoute.push("/feedback/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "RATE", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            ),
            " "
          )
        )
      );

    case "resolved":
      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
        _react2.default.createElement(
          "div",
          { className: "rainmaker-displayInline" },
          _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color complaint-timeline-status", label: "Complaint Resolved \xA0" }),
          employeeName && userRole !== "Citizen" && (createdBy == "GRO" ? _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color",
            containerStyle: nameContainerStyle,
            label: "by GRO ( " + employeeName + ", " + departmentName + ", " + designationName + ")"
          }) : _react2.default.createElement(_translationNode2.default, {
            labelClassName: "dark-color",
            containerStyle: nameContainerStyle,
            label: "by " + employeeName + ", " + departmentName + ", " + designationName
          }))
        ),
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-department", label: employeeDesignation }),
        media && _react2.default.createElement(
          "div",
          { style: { display: "flex" } },
          media.map(function (image, index) {
            var imgUrl = getImageSource(image, "small");
            return imgUrl && _react2.default.createElement(
              "div",
              {
                style: { marginRight: 8 },
                className: "complaint-detail-detail-section-padding-zero",
                id: "complaint-details-resolved-" + resolveStatusCount + "-image=" + index,
                key: index
              },
              _react2.default.createElement(_components.Image, {
                style: {
                  width: "97px",
                  height: "93px"
                },
                size: "medium",
                source: imgUrl,
                onClick: function onClick() {
                  return window.open(getImageSource(image, "small"), "Image");
                }
              })
            );
          })
        ),
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-comments", containerStyle: { width: "192px" }, label: comments }),
        currentStatus === "resolved" && (role === "citizen" || role === "csr") && _react2.default.createElement(
          "div",
          { className: "rainmaker-displayInline" },
          stepData.hasOwnProperty("showButton") && stepData.showButton && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            role !== "csr" && _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  changeRoute.push("/feedback/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "RATE", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            ),
            _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  role === "citizen" ? changeRoute.push("/reopen-complaint/" + encodeURIComponent(complaintNo)) : changeRoute.push("/reopen-complaint/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "REOPEN", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            )
          ),
          stepData.hasOwnProperty("showRateButton") && stepData.showRateButton && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            role !== "csr" && _react2.default.createElement(
              "div",
              {
                className: "complaint-details-timline-button",
                onClick: function onClick(e) {
                  changeRoute.push("/feedback/" + encodeURIComponent(complaintNo));
                }
              },
              _react2.default.createElement(_translationNode2.default, { label: "RATE", fontSize: "12px", labelStyle: timelineButtonLabelStyle, containerStyle: timelineButtonContainerStyle })
            )
          )
        )
      );

    case "closed":
      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-date", label: (0, _commons.getDateFromEpoch)(date) }),
        _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color complaint-timeline-status", label: "Closed" }),
        rating && _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_translationNode2.default, { labelClassName: "dark-color complaint-timeline-status", label: "Citizen Feedback" }),
          _react2.default.createElement(
            "div",
            { style: { display: "flex" } },
            " ",
            _react2.default.createElement(_translationNode2.default, {
              labelClassName: "rainmaker-small-font complaint-timeline-rating",
              labelStyle: { color: "#22b25f" },
              label: rating + "/5 "
            }),
            " ",
            _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-feedback", label: feedback && " (" + feedback + ")" })
          )
        ),
        _react2.default.createElement(_translationNode2.default, { labelClassName: "rainmaker-small-font complaint-timeline-comments", label: comments ? "\" " + comments + " \"" : "" })
      );
    case "pending":
      return _react2.default.createElement(
        "div",
        { className: "complaint-timeline-content-section" },
        _react2.default.createElement(_translationNode2.default, {
          style: { paddingTop: "6px" },
          labelClassName: "dark-color complaint-timeline-status",
          containerStyle: filedBy && filedBy.includes("@CSR") ? {
            display: "block",
            marginBottom: 5,
            paddingTop: "6px"
          } : {
            display: "inline-block",
            marginRight: "3px",
            paddingTop: "6px"
          },
          label: "Complaint pending at GRO"
        })
      );
    default:
      return null;
  }
};

var DueDate = function DueDate(_ref3) {
  var duedateText = _ref3.duedateText;

  return duedateText && duedateText.slaStatement && _react2.default.createElement(_translationNode2.default, {
    labelStyle: duedateText.slaStatement.toLowerCase().includes("overdue") ? { color: "#e74c3c" } : { color: "#22b25f" },
    className: "Complaint-details-duedate",
    label: duedateText.slaStatement,
    dynamicArray: [Math.abs(duedateText.daysCount)]
  });
};

var ComplaintTimeLine = function (_Component) {
  (0, _inherits3.default)(ComplaintTimeLine, _Component);

  function ComplaintTimeLine() {
    var _ref4;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ComplaintTimeLine);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref4 = ComplaintTimeLine.__proto__ || Object.getPrototypeOf(ComplaintTimeLine)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      allDesignation: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ComplaintTimeLine, [{
    key: "componentDidMount",

    //   componentDidMount() {
    //     // dispatch all the counts
    //     store.dispatch(prepareFinalObject("pgrStatusCount", 0));
    //   }
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var mdmsBody, payload, y, z, allDesignation;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mdmsBody = {
                  MdmsCriteria: {
                    tenantId: "km.kolkata",
                    moduleDetails: [{
                      moduleName: "common-masters",
                      masterDetails: [{ name: "Designation" }]
                    }]
                  }
                };
                _context.prev = 1;
                _context.next = 4;
                return (0, _api.httpRequest)("/egov-mdms-service/v1/_search", "", [], mdmsBody, [], {}, true);

              case 4:
                payload = _context.sent;
                y = payload.MdmsRes;
                z = y["common-masters"];
                allDesignation = z.Designation;

                this.setState({
                  allDesignation: allDesignation
                });
                _store2.default.dispatch((0, _actions.prepareFinalObject)("designationsById", allDesignation));
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);

                console.error(_context.t0);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 12]]);
      }));

      function componentDidMount() {
        return _ref5.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      openStatusCount = 0;
      rejectStatusCount = 0;
      resolveStatusCount = 0;
      assigneeStatusCount = 0;
      reassignRequestedCount = 0;
      var allDesignation = this.state.allDesignation;
      var _props = this.props,
          status = _props.status,
          history = _props.history,
          role = _props.role,
          timeLine = _props.timeLine,
          feedback = _props.feedback,
          rating = _props.rating,
          servicetype = _props.servicetype,
          filedBy = _props.filedBy,
          filedUserMobileNumber = _props.filedUserMobileNumber,
          timelineSLAStatus = _props.timelineSLAStatus,
          reopenValidChecker = _props.reopenValidChecker;


      if (timeLine && timeLine.length === 1 && timeLine[0].status === "open") {
        timeLine = [{ status: "pending" }].concat((0, _toConsumableArray3.default)(timeLine));
      }

      noReopen = !((role === "citizen" || role === "csr") && timeLine.some(function (obj) {
        return obj.status === "resolved" || obj.status === "rejected";
      }) && timeLine.some(function (obj) {
        return obj.status === "escalatedlevel2pending";
      }));
      var empRejectCount = timeLine.filter(function (action) {
        return action.status === "rejected";
      }).length;
      var empResolvedCount = timeLine.filter(function (action) {
        return action.status === "resolved";
      }).length;

      var steps = timeLine.map(function (step, key) {
        return {
          props: {
            active: true
          },
          labelProps: {
            icon: _react2.default.createElement(StatusIcon, { status: step.status })
          },
          contentProps: {
            style: {
              marginTop: "-50px",
              paddingRight: 0
            }
          },
          contentChildren: _react2.default.createElement(StatusContent, {
            stepData: step,
            servicetype: servicetype,
            currentStatus: status.toLowerCase(),
            changeRoute: history,
            feedback: feedback,
            rating: rating,
            role: role,
            allDesignation: allDesignation,
            filedBy: filedBy,
            filedUserMobileNumber: filedUserMobileNumber,
            reopenValidChecker: reopenValidChecker,
            timeLine: timeLine,
            empRejectCount: empRejectCount,
            empResolvedCount: empResolvedCount
          })
        };
      });

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_components.Card, {
          style: { paddingBottom: "0px" },
          textChildren: _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(
              "div",
              { className: "rainmaker-displayInline", style: { position: "relative" } },
              _react2.default.createElement(_components.Icon, { action: "action", name: "timeline", color: "#767676" }),
              " ",
              _react2.default.createElement(_translationNode2.default, { label: "Complaint Timeline", containerStyle: { marginLeft: "13px" }, labelClassName: "dark-heading" }),
              timelineSLAStatus && role && role !== "citizen" && status != "closed" && status != "resolved" && status != "rejected" && _react2.default.createElement(DueDate, { duedateText: timelineSLAStatus })
            ),
            _react2.default.createElement(
              "div",
              { className: "complaintTimeLineContainer" },
              _react2.default.createElement(_components.TimeLine, {
                stepperProps: {
                  orientation: "vertical",
                  borderLeft: "1px solid #fe7a51"
                },
                steps: steps
              })
            )
          )
        })
      );
    }
  }]);
  return ComplaintTimeLine;
}(_react.Component);

exports.default = ComplaintTimeLine;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/pgr/complaintDetails/components/ComplaintTimeLine/index.js
// module id = 3380
// module chunks = 1137